module.exports = __webpack_public_path__ + "img/no_vehicles.63592467.svg";